import { useState } from 'react';

const useEmailList = (defaultValue: string[] = []) => {
  const [emailList, setEmailList] = useState<string[]>(defaultValue);
  return { emailList, setEmailList };
};

export default useEmailList;
